import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

/**
 * DiscardChangesDialog — confirmation shown when a user tries to leave a form
 * with unsaved changes. "Keep Editing" stays; "Discard" allows the navigation.
 */
export const DiscardChangesDialog = ({
  open,
  onKeepEditing,
  onDiscard,
  title = 'Discard changes?',
  description = 'You have unsaved changes. If you leave now, your changes will be lost.',
  keepEditingLabel = 'Keep Editing',
  discardLabel = 'Discard',
}) => {
  return (
    <AlertDialog open={open} onOpenChange={(o) => { if (!o) onKeepEditing(); }}>
      <AlertDialogContent data-testid="discard-changes-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={onKeepEditing}
            data-testid="keep-editing-btn"
          >
            {keepEditingLabel}
          </Button>
          <Button
            variant="destructive"
            onClick={onDiscard}
            data-testid="discard-changes-btn"
          >
            {discardLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DiscardChangesDialog;
